<template>
  <div class="bulletChat">
    <div style="width: 45%; margin: 0 auto; pointer-events: none; box-sizing: border-box">
      <div v-show="realData.length > 0" class="funnyNewsTicker fnt-radius fnt-shadow fnt-easing" id="funnyNewsTicker1">
        <ul>
          <li v-for="(item, i) in listData" :key="i" @mouseleave="mouseoutMarquee(item)" @mouseenter="mouseoverMarquee(item)">
            <div class="fnt-content" data-link="###">
              <template v-if="item.isMarquee">
                <marquee behavior="scroll" direction="left">{{ item.value }}</marquee>
              </template>
              <template v-else-if="!item.isMarquee">
                <span>{{ item.value }}</span>
              </template>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      dataIndex: 0,
      realData: [],
      listData: [
        {
          value: "",
          isMarquee: false,
        },
        {
          value: "",
          isMarquee: false,
        },
        {
          value: "",
          isMarquee: false,
        },
        {
          value: "",
          isMarquee: false,
        },
      ],
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    this.getBulletData();
    $(document).ready(function () {
      jQuery("#funnyNewsTicker1").funnyNewsTicker({
        width: "80%",
        timer: 5000,
        titlecolor: "#FFF",
        itembgcolor: "rgba(0,28,25,0.8)",
        infobgcolor: "#1a935c",
        buttonstyle: "white",
        bordercolor: "rgba(0,28,25,1)",
        cbFunc: function () {
          that.listData.forEach((element) => {
            element.isMarquee = false;
          });
          that.dataIndex = that.dataIndex + 1;
          that.refreshBulletReal();
          that.$forceUpdate();
        },
      });
    });
  },
  //方法集合
  methods: {
    getBulletData() {
      let that = this;
      let findTltxListUrl = CONFIG.requestName + this.$apiOpt.findTltxList;
      this.$apiUtils
        .get(findTltxListUrl, {
          customerId: this.$store.state.customerId,
        })
        .then(function (data) {
          if (data.length) {
            that.realData = [];
            let times = Math.floor(that.listData.length / data.length);
            for (let i = 0; i < times; i++) {
              data.forEach((item, n) => {
                let valueList = item.value;
                let deviceName = item.deviceName;
                let valueStr = "";
                valueList.forEach((item_, n_) => {
                  valueStr +=
                    item_.signalName +
                    ": " +
                    (item_.signalValue
                      ? item_.signalValue + item_.signalUnit
                      : "--");
                });
                let tmpStr = n + 1 + ". " + deviceName + ": " + valueStr;
                that.realData.push(tmpStr);
              });
            }
            that.dataIndex = 0;
            that.refreshBulletReal();
            that.$forceUpdate();
          }
        });
    },
    //当实际数据比子弹条数多时，轮完后向后跳一页
    refreshBulletReal() {
      let that = this;
      if (this.realData.length > 0) {
        if (that.dataIndex % that.listData.length === 0) {
          this.listData.forEach((item, n) => {
            let idx = (n + that.dataIndex) % that.realData.length;
            item.value = that.realData[idx];
          });
        }
        if (
          this.dataIndex % this.listData.length ===
          this.listData.length - 1
        ) {
          let idx = (this.dataIndex + 1) % this.realData.length;
          this.listData[0].value = this.realData[idx];
        }
      }
    },
    mouseoutMarquee(item) {
      item.isMarquee = false;
      this.$forceUpdate();
    },
    mouseoverMarquee(item) {
      item.isMarquee = true;
      this.$forceUpdate();
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped="scoped">
.bulletChat {
  z-index: 2;
  pointer-events: all;
  bottom: -60px;
  width: 100%;
  position: absolute;
  pointer-events: none;
}
.funnyNewsTicker {
  width: 100%;
  overflow: hidden;
  height: 440px;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
  margin: 0 auto;
  pointer-events: all;
}
.funnyNewsTicker > ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
}
.funnyNewsTicker > ul > li {
  display: none;
  width: 100%;
  height: 100px;
  background: #fff;
  position: absolute;
  overflow: hidden;
}
.funnyNewsTicker > ul > li > .fnt-content {
  position: absolute;
  top: 0;
  bottom: 30px;
  left: 0;
  right: 0;
  box-sizing: border-box;
  // overflow: hidden;
  line-height: 50px;
  height: 100%;
  font-size: 28px;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 20px;
}
.funnyNewsTicker > ul > li > .fnt-content a {
  text-decoration: none;
}
.funnyNewsTicker > ul > li > .fnt-content a:hover {
  text-decoration: underline;
}
.funnyNewsTicker > ul > li > .fnt-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  padding: 5px;
  border-top: solid 1px #ddd;
}
.funnyNewsTicker > ul > li > .fnt-info a {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #0f0;
  opacity: 0.2;
  cursor: pointer;
}
.funnyNewsTicker > ul > li > .fnt-info a:hover {
  opacity: 1;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-facebook-black {
  background: url(./img/fnt-buttons-black.png) 0 0 no-repeat;
  float: left;
  margin-right: 5px;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-twitter-black {
  background: url(./img/fnt-buttons-black.png) -20px 0 no-repeat;
  float: left;
  margin-right: 5px;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-google-black {
  background: url(./img/fnt-buttons-black.png) -40px 0 no-repeat;
  float: left;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-link-black {
  background: url(./img/fnt-buttons-black.png) -60px 0 no-repeat;
  float: right;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-facebook-white {
  background: url(./img/fnt-buttons-white.png) 0 0 no-repeat;
  float: left;
  margin-right: 5px;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-twitter-white {
  background: url(./img/fnt-buttons-white.png) -20px 0 no-repeat;
  float: left;
  margin-right: 5px;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-google-white {
  background: url(./img/fnt-buttons-white.png) -40px 0 no-repeat;
  float: left;
}
.funnyNewsTicker > ul > li > .fnt-info a.fnt-link-white {
  background: url(./img/fnt-buttons-white.png) -60px 0 no-repeat;
  float: right;
}
.funnyNewsTicker > ul > li > .fnt-info span {
  position: absolute;
  left: 80px;
  right: 30px;
  text-align: center;
  opacity: 0.4;
  z-index: 0;
  font-size: 13px;
  cursor: default;
}
.funnyNewsTicker > div {
  width: 50px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  opacity: 0.3;
}
.funnyNewsTicker > div:hover {
  opacity: 1;
}
.funnyNewsTicker > div.fnt-top-arrow {
  top: 0;
  background: url(./img/fnt-arrows-black.png) top no-repeat;
}
.funnyNewsTicker > div.fnt-bottom-arrow {
  bottom: 0;
  background: url(./img/fnt-arrows-black.png) bottom no-repeat;
}

.funnyNewsTicker .fnt-top0 {
  -ms-transform: scale(0.8);
  -webkit-transform: scale(0.85);
  transform: scale(0.85);
  opacity: 0;
  top: -30px;
  z-index: 1;
  display: block;
}
.funnyNewsTicker .fnt-top1 {
  -ms-transform: scale(0.87);
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
  opacity: 0;
  top: 0px;
  z-index: 2;
  display: block;
}
.funnyNewsTicker .fnt-top2 {
  transform: scale(0.9);
  opacity: 0.3;
  top: 35px;
  z-index: 3;
  display: block;
}
.funnyNewsTicker .fnt-active {
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  top: 75px;
  z-index: 10;
  display: block;
}
.funnyNewsTicker .fnt-bottom2 {
  transform: scale(0.9);
  opacity: 0.3;
  top: 115px;
  z-index: 6;
  display: block;
}
.funnyNewsTicker .fnt-bottom1 {
  -ms-transform: scale(0.87);
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
  opacity: 0;
  top: 150px;
  z-index: 5;
  display: block;
}
.funnyNewsTicker .fnt-bottom0 {
  -ms-transform: scale(0.8);
  -webkit-transform: scale(0.85);
  transform: scale(0.85);
  opacity: 0;
  top: 180px;
  z-index: 4;
  display: block;
}

.fnt-easing2 {
  transition: 0.25s linear;
  -moz-transition: 0.25s linear;
  -webkit-transition: 0.25s linear;
}
.fnt-easing li {
  transition: 0.5s ease-out;
  -moz-transition: 0.5s ease-out;
  -webkit-transition: 0.5s ease-out;
}
.fnt-radius li {
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.fnt-radius2 li {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.fnt-shadow li {
  -webkit-box-shadow: 0px 0px 10px 0px rgba(100, 100, 100, 0.3);
  -moz-box-shadow: 0px 0px 10px 0px rgba(100, 100, 100, 0.3);
  box-shadow: 0px 0px 10px 0px rgba(100, 100, 100, 0.3);
}
.fnt-shadow-big {
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5) !important;
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5) !important;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5) !important;
}
</style>
